const declaredHeaders = [
  'APV#',
  'Posting Date',
  'CV #',
  'CV Date',
  'Check #',
  'Check Available Date',
  'Released Date'
]

// private ////////////////////////////////////////////////// start
const validateNumber = number => {
  if (declaredHeaders.includes(number)) {
    return false
  }
  if (isNaN(number)) {
    return true
  }
  if (number.charAt(0) !== '3') {
    return true
  }
  if (number.length !== 9) {
    return true
  }
  return false
}

const validateDate = date => {
  if (declaredHeaders.includes(date)) {
    return false
  }
  if (!date.match('^\\d{2}/\\d{2}/\\d{4}$')) {
    return true
  }
  return false
}
/// //////////////////////////////////////////////////////////// end

// public ////////////////////////////////////////////////////// start
const numbers = (number, date) => {
  if (number !== '') {
    return validateNumber(number)
  }
  if (date !== '') {
    return true
  }
}

const dates = (date, number) => {
  if (date !== '') {
    return validateDate(date)
  }
  if (number !== '') {
    return true
  }
}

const checkAvailabledDates = (date, number) => {
  if (date !== '') {
    return validateDate(date)
  }
  if (number !== '') {
    return true
  }
}

const checkNumbers = (number, date) => {
  if (number !== '') {
    if (declaredHeaders.includes(number)) {
      return false
    }
    return false
  }
  if (date !== '') {
    return true
  }
}

const releasedDate = date => {
  if (date !== '') {
    return validateDate(date)
  }
  return false
}
/// /////////////////////////////////////////////////////////////  end

export default {
  numbers,
  dates,
  checkNumbers,
  checkAvailabledDates,
  releasedDate
}
